// src/stores/mediaStore.tsx
"use client";

import { create } from "zustand";
import { MediaRecord } from "@/types"


interface MediaState {
  mediaRecords: MediaRecord[];
  totalMedia: number;
  setMediaRecords: (records: MediaRecord[] | ((prevRecords: MediaRecord[]) => MediaRecord[])) => void;
  setTotalMedia: (total: number | ((prevTotal: number) => number)) => void;
  updateMediaRecord: (record: Partial<MediaRecord> & { id: number }) => void;
  addMediaRecord: (record: MediaRecord) => void;
  removeMediaRecord: (id: number) => void;
}

export const useMediaStore = create<MediaState>((set) => ({
  mediaRecords: [],
  totalMedia: 0,
  setMediaRecords: (records) =>
    set((state) => ({
      mediaRecords: typeof records === "function" ? records(state.mediaRecords) : records,
    })),
  setTotalMedia: (total) =>
    set((state) => ({
      totalMedia: typeof total === "function" ? total(state.totalMedia) : total,
    })),
  updateMediaRecord: (record) =>
    set((state) => {
      const existingRecord = state.mediaRecords.find((r) => r.id === record.id);
      if (existingRecord) {
        return {
          mediaRecords: state.mediaRecords.map((r) =>
            r.id === record.id ? { ...r, ...record } : r
          ),
        };
      } else if (record.visible === 1) {
        const newRecord: MediaRecord = {
          id: record.id,
          name: record.name || "Unknown",
          display_name: record.display_name || "Unknown",
          subtitle: record.subtitle || "",
          url: record.url || "",
          img_final: record.img_final || "fallback.webp",
          top: record.top,
          sponsored: record.sponsored,
          country: record.country,
          DA: record.DA,
          DR: record.DR,
          TAT: record.TAT,
          category: record.category,
          market_price: record.market_price,
          visible: record.visible,
          hyperlink: record.hyperlink,
          indexed: record.indexed,
          dofollow: record.dofollow,
          location: record.location,
          type: record.type,
          coverage: record.coverage || "1,2,3,4,5",
          popularity: record.popularity,
          date_added: record.date_added,
        };
        const newRecords = [...state.mediaRecords];
        const insertIndex = newRecords.findIndex((r) => r.id > record.id);
        if (insertIndex === -1) {
          newRecords.push(newRecord);
        } else {
          newRecords.splice(insertIndex, 0, newRecord);
        }
        return {
          mediaRecords: newRecords,
          totalMedia: state.totalMedia + 1,
        };
      }
      return state;
    }),
  addMediaRecord: (record) =>
    set((state) => ({
      mediaRecords: [...state.mediaRecords, record],
      totalMedia: state.totalMedia + 1,
    })),
  removeMediaRecord: (id) =>
    set((state) => ({
      mediaRecords: state.mediaRecords.filter((r) => r.id !== id),
      totalMedia: state.totalMedia - 1,
    })),
}));